import { render, staticRenderFns } from "./goodsIndex.vue?vue&type=template&id=54194bcc&scoped=true"
import script from "./goodsIndex.vue?vue&type=script&lang=js"
export * from "./goodsIndex.vue?vue&type=script&lang=js"
import style0 from "./goodsIndex.vue?vue&type=style&index=0&id=54194bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54194bcc",
  null
  
)

export default component.exports